/* eslint-disable no-use-before-define,no-restricted-globals */
import { ajax, safeURL, parseJson, pickObject, setOrigin, getConfig, toQueryString, cleanObject, } from '../twd/twd'
import { adjustView } from './init-nav'

export const getUrlDefaultValues = () => {
    var defaultView = 'overview'
    var defaultArgs = {}
    var defaultModal = ''
    var defaultModalArgs = {}

    let u = new URL(location.href)
    let sp = u.searchParams
    if (sp.has('show')) {
        defaultView = sp.get('show').split('.')[0]

        let p = { view: sp.get('show') }
        for (let [k,v] of sp.entries()) {
            p[k] = v
        }
        defaultArgs = p
    }
    else if (u.hash) {
        let h = u.hash.slice(1)
        defaultView = h.split('.')[0]

        let p = {view:h}
        for (let [k,v] of sp.entries()) {
            p[k] = v
        }
        defaultArgs = p
    }

    if (sp.has('modal')) {
        defaultModal = sp.get('modal').split('.')[0]

        let p = {}
        for (let [k,v] of sp.entries()) {
            p[k] = v
        }
        defaultModalArgs = p
    }

    return {
        defaultView, defaultArgs,
        defaultModal, defaultModalArgs
    }
}

export const getUrlLinkInfo = async ({setView, setArgs, setModal, setModalArgs}) => {
    let u = new URL(location.href)
    let sp = u.searchParams
    let action = sp.get('action')
    let infoId = sp.get('infoId')
    if (!action || !infoId) return

    try {
        let { data } = await ajax ({
            url: '/esb/report/emailTemplates/linkInfo/' + infoId,
            method: 'GET',
            params: { action }
        })

        let sp = new URLSearchParams((await data || {}).params || '')
        let nav = sp.get('pa-nav')
        if (!nav) return

        let url = safeURL(sp.get('pa-arg'))
        if (!url) return

        var view = 'tools'
        var args = { view:'tools.load-url', url:url.toString(), frameName:'content' }
        var origin = setOrigin(url.searchParams.get('p_from'))

        if (nav==='pa-nav-blotter') {
            view = 'orders'
            args = { view: 'orders' }
        }
        else if (nav==='pa-nav-issue') {
            let cusip = url.searchParams.get('p_cusip')
            view = 'bond-detail'
            args = {
                view: 'bond-detail.bond-detail',
                cusip,
                from: safeURL(origin),
                showBackLink: 'N',
            }
        } else if ((nav === 'pa-nav-order' || nav === 'pa-nav-get-bond-quote')
            && getConfig('entitlements.ETradeOrderTicket', 'No') === 'Yes'
        ) {
            view = 'order-ticket'

            let acctNo = url.searchParams.get('p_acct_no')
            if (acctNo && url.searchParams.get("p_acct_no_encrypted") === 'Y') {
                try {
                    const {data: acct_} = await ajax({
                        url: '/esb/portfolio/trades/accountTransform',
                        method: 'POST',
                        headers_: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        type: 'text',
                        body: toQueryString({
                            p_acct_no: acctNo
                        }),
                    })
                    acctNo = await acct_
                } catch (e) {
                    console.error('init-url.order-ticket', e)
                    acctNo = null
                }
            }

            args = cleanObject({
                view: 'order-ticket.order-ticket',
                acctNo,
                cusip: url.searchParams.get('p_cusip'),
                action: url.searchParams.get('p_action'),
                qty: url.searchParams.get('p_qty') || url.searchParams.get('p_quantity'),
                from: safeURL(origin),
            })
        } else if ((nav === 'pa-nav-buy-quote' || nav === 'pa-nav-sell-quote')
            && getConfig('entitlements.ETradeOrderTicket', 'No') === 'Yes'
        ) {
            view = 'order-ticket'

            const isSell = nav === 'pa-nav-sell-quote'
            const orderNo = url.searchParams.get('p_quote_id')

            const {data} = ajax({
                url: '/esb/retailservice/etradeBestQuote/' + orderNo,
                method: 'GET',
                params: {
                    side: isSell ? 'S' : 'B'
                }
            })

            const action = isSell ? 'S' : 'B'
            const sourceAction = isSell ? 'Y' : 'Z'

            let rs = await (await data || {})
            args = cleanObject({
                view: 'order-ticket.order-ticket',
                acctNo: url.searchParams.get('p_acct_no') || rs.accountNumber,
                cusip: rs.cusip,
                action,
                qty: rs.quantity,
                price: rs.price,
                yld: rs['yield'],
                sourceAction,
                sourceOrderNo: `${orderNo}|${rs.quoteId || ''}`,
                from: safeURL(origin),
            })
        }
        else if (nav==='pa-nav-get-bond-quote') {
            args = {
                view:'tools.get-a-bond-quote',
                url: url.toString(),
                actionSubset: 'WF',
                ts: Date.now(),
            }
        }
        else if (nav==='pa-nav-ladder-builder') {
            view = 'bond-ladder-builder'
            args = {}
        }
        else if (nav==='pa-nav-bond-advanced-search') {
            view = 'advanced-screener'
            args = { view:'advanced-screener' }
        }
        else if (nav==='pa-nav-run-saved-search') {
            view = 'overview'
            args = { view:'overview' }

            let gn = 'FIXED_INCOME_SOLUTION_CENTER'
            let pn = url.searchParams.get('p_query_name')
            let { data } = await ajax ({
                url: '/esb/retailservice/fixedIncomeSystemSearchService/getByQueryNameList',
                method: 'POST',
                params: {
                    quickPickGroupSubType: gn,
                    quickPickItemNameList: [pn],
                }
            })

            let sp = parseJson(pickObject(
                await data,
                `fixedIncomeSystemSearchDto.${gn}.${pn}`,
                {}
            ).queryText)

            if (sp) {
                view = 'offerings'
                delete sp['savedQuickPickId']
                args = {
                    view,
                    searchParams: Object.assign({
                        persistToPreviousSearches: false,
                    }, sp),
                    _ts: Date.now()
                }
            }
        }
        else if (nav==='pa-nav-primary-cds') {
            view = 'offerings'
            args = {
                view,
                searchParams: {
                    holdInvType: ['S'],
                    offeringType: ['primary','ask-side'],
                    primarySecondary: ['primary'],
                    persistToPreviousSearches: false,
                },
                _ts: Date.now(),
                from:'overview'
            }
        }
        else if (nav==='pa-nav-program-notes') {
            view = 'offerings'
            args = {
                view,
                searchParams: {
                    holdInvType: ['C'],
                    offeringType: ['primary','ask-side'],
                    primarySecondary: ['primary'],
                    persistToPreviousSearches: false,
                },
                _ts: Date.now(),
                from:'overview'
            }
        }

        const [v, a, m, mA] = adjustView({view, args})
        if (v) {
            setArgs(a)
            setView(v)
        }
        if (m) {
            setModalArgs(mA)
            setModal(m)
        }

    } catch(e) {
        console.log('init-error', e)
    }
}
